export default "/images/ic_sushiman.svg?c807389b57c047086ab5c2def0501680";